export function isExternalLink(href: string) {
  return href.startsWith("http") || href.startsWith("mailto");
}
